import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserCargoOfficerList from "./user-cargo-officer-list";
import UserCargoOfficerListError from "./user-cargo-officer-list-error";
import UserCargoOfficerListParams from "./user-cargo-officer-list-params";

const useCargoOfficerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserCargoOfficerList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserCargoOfficerListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOfficerList = await userService.getCargoOfficerList(
        params,
        signal,
      );

      setData(cargoOfficerList);
      setIsLoading(false);
    } catch (_error) {
      const error = _error as UserCargoOfficerListError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useCargoOfficerList;
